import $ from 'jquery'
const object = autostrategyObject;

const simForm = $('.js-sim-form');

simForm.on('submit', function () {
    run_simulation()
})

function run_simulation() {
    event.preventDefault();
    event.stopPropagation();

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: simForm.serialize() + '&action=autostrategy_run_sim&nonce=' + object.nonce,
        success: function (res) {
            if (res.length !== 0) {
                var priceContainerFR = $('.js-price-fr')
                var priceContainerPL = $('.js-price-pl')
                var co2ContainerFR = $('.js-co2-fr')
                var co2ContainerPL = $('.js-co2-pl')
                var weightContainerFR = $('.js-weight-fr')
                var weightContainerPL = $('.js-weight-pl')
                var greyCardContainerFR = $('.js-grey-card-fr')
                var greyCardContainerPL = $('.js-grey-card-pl')
                var appFeesContainerFR = $('.js-app-fees-fr')
                var appFeesContainerPL = $('.js-app-fees-pl')
                var transportCostContainerFR = $('.js-transport-cost-fr')
                var transportCostContainerPL = $('.js-transport-cost-pl')
                var totalContainerFR = $('.js-total-fr')
                var totalContainerPL = $('.js-total-pl')
                var runSimButton = $('.js-run-sim')
                var runSimButtonText = runSimButton.attr('data-runned-text')
                var valuesCol = $('.js-values-col')
                var resultCol = $('.js-result-col')

                runSimButton.addClass('autostrategy-btn--classic--black')
                runSimButton.removeClass('autostrategy-btn--classic--white')
                runSimButton.html(runSimButtonText)

                valuesCol.removeClass('part-simulator__values--active')
                resultCol.addClass('part-simulator__result--active')


                priceContainerPL.html(res.data.price_pl + ' €')
                co2ContainerPL.html(res.data.co2_pl + ' €')
                weightContainerPL.html(res.data.weight_pl + ' €')
                greyCardContainerPL.html(res.data.grey_card_pl + ' €')
                appFeesContainerPL.html(res.data.app_fees_pl + ' €')
                transportCostContainerPL.html(res.data.transport_cost_pl + ' €')
                totalContainerPL.html(res.data.total_pl + ' € ')


                priceContainerFR.html(res.data.price_fr + ' €')
                co2ContainerFR.html(res.data.co2_fr + ' €')
                weightContainerFR.html(res.data.weight_fr + ' €')
                greyCardContainerFR.html(res.data.grey_card_fr + ' €')
                appFeesContainerFR.html(res.data.app_fees_fr + ' €')
                transportCostContainerFR.html(res.data.transport_cost_fr + ' €')
                totalContainerFR.html(res.data.total_fr + ' € ')

                //Add space every 3 number
                $('.part-simulator__result-value').each(function () {
                    var text = $(this).text();
                    text = text.split('').reverse().join('');
                    text = text.replace(/\d{3}(?!$)/g, '$& ');
                    text = text.split('').reverse().join('');
                    $(this).text(text);
                });

                if (res.data.add_total_pl.length !== 0) {
                    totalContainerPL.append( ' ' + res.data.add_total_pl )
                }

                if (res.data.add_total_fr.length !== 0) {
                    totalContainerFR.append( ' ' + res.data.add_total_fr )
                }
            }
        },
    });
}

$('.js-redo-sim-mobile').on('click', function () {
    var valuesCol = $('.js-values-col')
    var resultCol = $('.js-result-col')

    valuesCol.addClass('part-simulator__values--active')
    resultCol.removeClass('part-simulator__result--active')


    var runSimButton = $('.js-run-sim')
    var runSimButtonText = runSimButton.attr('data-not-runned-text')

    runSimButton.addClass('autostrategy-btn--classic--white')
    runSimButton.removeClass('autostrategy-btn--classic--black')
    runSimButton.html(runSimButtonText)
})
